import '_Namespace';
import '../Fusion/Document';
import '../Fusion/Component/Icon';
import '../Fusion/Component/Header';
import '../Fusion/Component/Sidebar';
import '../Fusion/Component/Dialog';
import bubble from '../Fusion/Component/Stopper';
import '../Fusion/FAQ';
import '../Fusion/Person';
import '../Fusion/Consultation';
import '../Fusion/Overwrite/Text';
import '../Fusion/Component/Review';
import './Accordion';
import './SpamProtection';
import '../Fusion/FormsMSDynamic/FormsMSDynamic';
import '../Fusion/Component/InteractiveToolIFrame';
import '../Fusion/Content/TextWithVideo/TextWithVideoVertical';

document.addEventListener('DOMContentLoaded', function () {
    _gg.domReady(function () {
        _gg.onReadyRun();
        bubble();
    });
});

function handleClickableElements() {
    const elements = document.querySelectorAll('.--clickable-element');
    elements.forEach((el) => {
        el.addEventListener('click', (event) => {
            const link = event.currentTarget.querySelector('.link');
            if (link) {
                link.click();
            }
        });
    });
}

handleClickableElements();
